const Getters = {
  getAggregateDataFromState: (state) => {
    //console.log('getter_state')
    //console.log(state)
    return state.aggregateData
  }
}

export default Getters
